var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.btnVisialbe && !_vm.hideBtn)?_c('guide-button',{staticClass:"pos-c",on:{"click":_vm.next}},[_vm._v(_vm._s(_vm.btnText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }